<template>
    <div class="modal-backdrop">
        <div class="card col-lg-5 col-md-8 mt-md-4 col-11 p-0">
            <div class="modal-content postmodalcontent" >
                <div class="modal-header borderbottom p-4">
                    <div class="d-lg-flex">
                      <h5 class="modal-title font16-bold ml-2" id="exampleModalLabel">Job Details</h5>
                    </div>   
                    <button type="button" class="close" @click="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div v-if="pageloader" class="">
                    <img src="../assets/loading_gif1.gif" class="pageloader1" alt="loading">
                </div>
                <div class="modal-body bodymodal11" v-else>
                    <div class="col-12 backgroundcolor1 borderbottom p-2 pb-4 d-flex">
                      <div class="col-2">
                        <img :src="JobObject.companyProfileLink" class="img-fluid rounded-circle" alt="companylogo">
                      </div>
                      <div class="col-10 pt-2">
                        <div class="d-flex justify-content-between">
                          <span class="fontsize24 black proximanova stylebold">{{JobObject.jobTitle}}</span>
                          <!-- <img src="../assets/horizontal_menu_icon.svg" width="20px" height="20px" class="mr-5" alt=""> -->
                        </div>
                        <div class="d-flex flex-column mt-2">
                          <span class="fontsize16 black proximanova">{{JobObject.companyName}}</span>
                          <div>
                            <span class="fontsize16 black60 proximanova">{{JobObject.industry}}</span>
                            <span class="ml-2 mr-2 black60">|</span>
                            <span class="fontsize16 black60 proximanova">{{JobObject.country}}</span>
                          </div>
                        </div>
                        <div class="d-flex mt-2 justify-content-between">
                          <div class="mt-1">
                            <span class="fontsizemd black stylebold proximanova">{{JobObject.creationD | moment("from", "now", true)}} ago</span>
                            <span class="ml-2 mr-2 black60">|</span>
                            <span class="forgot-password proximanova">{{JobObject.jobApplicantCount}} Candidates Applied</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 p-3">
                      <div class="d-flex mb-2">
                        <div class="pl-2 pr-1">
                          <img src="../assets/JobViewHired.svg" alt="job">
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black60 proximanova">Employment Type</span>
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black proximanova" v-if="totalJobDetails.employeeType">{{totalJobDetails.employeeType.indexDetailName}}</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="pl-2 pr-1">
                          <img src="../assets/JobViewSeniority.svg" alt="seniority">
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black60 proximanova">Seniority</span>
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black proximanova" totalJobDetails.seniorityType>{{totalJobDetails.seniorityType.indexDetailName}}</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="pl-2 pr-1">
                          <img src="../assets/JobViewAmount.svg" alt="payscale">
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black60 proximanova">Pay Scale</span>
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black proximanova">{{totalJobDetails.payScaleFrom}} - {{totalJobDetails.payScaleTo}}</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="pl-2 pr-1">
                          <img src="../assets/JobViewLocation.svg" alt="location">
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black60 proximanova">Job Location</span>
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black proximanova">{{totalJobDetails.city.cityName}}, {{totalJobDetails.country.countryName}}, {{totalJobDetails.zipcode}}</span>
                        </div>
                      </div>
                      <div class="horizontalline mt-3"></div>
                    </div>
                    <div class="col-12">
                      <div class="d-flex flex-column pl-3 pr-3 pt-2 pb-1">
                        <span class="fontsize16 stylebold proximanova black mb-2">Job Description</span>
                        <!-- <span class="fontsizemd proximanova black mb-3 lineheight22" v-if="totalJobDetails.jobDesc">{{totalJobDetails.jobDesc}}</span> -->
                        <quill-editor v-model="totalJobDetails.jobDesc" :options="editorOption" class="quill1" disabled v-if="totalJobDetails.jobDesc"></quill-editor>
                        <span class="fontsizemd proximanova black60 mb-2 lineheight22" v-else>Job description is not added</span>
                      </div>
                      <div class="horizontalline mt-1 mb-2"></div>
                    </div>
                    <div class="col-12">
                      <div class="d-flex flex-column pl-3 pr-3 pt-2 pb-1">
                        <span class="fontsize16 stylebold proximanova black mb-2">Skills Required</span>
                        <div class="row no-gutters mt-2 ml-0">
                            <div v-if="totalJobDetails.addedSkillsList.length > 0" class="d-flex flex-wrap mb-3 col" >
                                <div v-for="(skill, index) in totalJobDetails.addedSkillsList" :key="index" >
                                  <div class="pl-3 pr-3 p-1 mr-3 black60 fontsize12 backgroundcolor2 stylebold borderradius10 proximanova d-flex mt-1">
                                      {{skill.skillName}}
                                  </div>
                                </div>
                            </div>
                            <div v-else>
                                <span class="fontsizemd proximanova black60 mb-3 lineheight22">Skills are not added to this job.</span>
                            </div>
                        </div>
                      </div>
                      <div class="horizontalline mt-3 mb-3"></div>
                    </div>
                    <div class="col-12">
                      <div class="d-flex flex-column pl-3 pr-3 pt-2 pb-1">
                        <span class="fontsize16 stylebold proximanova black mb-2">More Details</span>
                        <span class="fontsizemd proximanova black mb-2 lineheight22">Screening Questions.</span>
                        <span class="fontsizemd proximanova black60 mb-2 lineheight22">Any screening questions added will appear once you click Apply.</span>
                        <div class="row no-gutters mt-1 mb-2 ml-0">
                            <div v-if="totalJobDetails.screeningQuestionsList.length > 0" class="d-flex flex-wrap mb-3 col" >
                                <div v-for="(qsn, index) in totalJobDetails.screeningQuestionsList" :key="index" >
                                  <div class="pl-3 pr-3 p-1 mr-3 black60 fontsize12 backgroundcolor2 stylebold borderradius10 proximanova d-flex mt-1">
                                      {{qsn.question}}
                                  </div>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>  
</template>

<script>
import httpjob from "@/js/http-postjob.js"
export default{
   data() {
    return{
        pageloader : true,
      savedIntroVideoLink : null,
      addedSkillsList : ['java', 'html', 'css', 'javascript'],
      companyDetails : {},
      totalJobDetails : {},
      editorOption: {
        theme: 'bubble'
      },
    }
  },
  props : [
        'JobObject'
    ],
  methods:{
    close() {
      this.$emit('closePreviewModal', "cancel" );
    },
    //fetch seniority types list
    getJobDetails(){
        httpjob.get('/postjob/getJobDataById?jobId='+this.JobObject.jobId)
        .then((response) => {
            this.pageloader = false;
            console.log("job details : ", response)
            this.totalJobDetails = response.data;
        }).catch((e) => {
            console.log(e)
            this.pageloader = false;
        })
    }
  },
   mounted() {
    console.log("jobobejct : ", this.JobObject)
    this.getJobDetails()
  },

}

</script>

<style scoped>
.pageloader1{
    width: 8%;
    margin-left: 45%;
    margin-top: 5%;
    margin-bottom: 5%;
}
.modal-backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000 !important;
}
#introVideo{
  width: 100%;
  background: black;
}
.card {
    padding: -5px !important;
    margin: 0 auto;
}
label input[type="radio"]:checked ~ span {
    color: #007AFF;
}
.postmodalcontent{
  border: none !important;
}
.btn:focus{
  box-shadow: none;
}
.tagLineReport{
	height: 10px;
	color: #1F1F1F;
	font-size: 10px;
	font-weight: bold;
	letter-spacing: 0;
	font-style: italic;
  opacity: 60%
}
.button-cancel11 {
  border: 1px solid #1f1f1f;
  border-radius: 4px;
  transition : ease-out 0.3s;
  font-size: 14px !important;
	position: relative;
	z-index : 1;
}
.modal-header{
  border: none;
}
.bodymodal11{
  padding: 0 !important;
  height: 80vh;
  overflow-y: auto;
  /* .row{
    margin: -15px;
  } */
}
.bodymodal11{
  background-color: white;
}
.profile-border{
  padding: 2px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
/*hide scroll bar */
.bodymodal11::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.bodymodal11 {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.close{
  padding: 1px 7px 5px 7px !important;
  margin-top: -3px !important;
  margin-right: 5px !important;
}
.close:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
@media screen and  (max-width : 600px){
  .card{
    margin-top: 4%;
  }
}
</style>